import React from 'react';
import './NavDock.css'
import { Link, useLocation } from 'react-router-dom'

import HomeIcon from '../../Assets/Icons/Home.svg'
import TicketIcon from '../../Assets/Icons/Ticket.svg'
import MapIcon from '../../Assets/Icons/Map.svg'
import NotifIcon from '../../Assets/Icons/Notif.svg'

const NavDock = (props) => {
    const location = useLocation(); 

    const menuItems = [
        { icon: HomeIcon, label: 'Home', path: '/home' },
        { icon: TicketIcon, label: 'Tickets', path: '/ticket' },
        { icon: MapIcon, label: 'Map', path: '/map' },    
    ];


    const activeIndex = menuItems.findIndex(item => item.path === location.pathname);

    return ( 
        <div className='NavDock'>
            <div className='BottomBar'>
               
                <div 
                    className="Indicator" 
                    style={{ 
                        transform: `translateX(calc(${activeIndex * 100}%))`,
                        width: `${100 / menuItems.length}%` 
                    }}
                >
                    <img className={props.NotchClass} src={props.Curve} alt='' />
                </div>

                <ul>
                    {menuItems.map((item, index) => (
                        <Link 
                            key={index} 
                            className={activeIndex === index ? 'active' : ''}
                            to={item.path}
                        >
                            <img src={item.icon} alt={item.label} />
                        </Link>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default NavDock;